import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  DrawChart,
  ChartIncludeColumn,
  DrawChart1,
} from "./Chart/ChartInclude";
import {
  NORECORDS,
  decruptCipher,
  CustomLoader,
} from "../Services/CommonLibrary";
import "./Home.css";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import {
  getInactiveUserExport,
  serviceSuperviewUserCount,
  ServiceAllprogramList,
  serviceSuperviewMesageGraph,
  serviceSuperviewCallDetail,
  serviceSuperviewUserProgramCount,
  serviceSuperviewUserDivisionCount,
  serviceSuperviewUserDivisionDateCount,
  serviceDivisionPractice,
  serviceSuperviewInclinicCall,
  serviceSuperviewCoachRating,
  serviceSuperviewUserDivisionPracticeCount,
  serviceSuperviewActiveUserCount,
  serviceMessageData,
  serviceExportData,
  serviceCallData,
  serviceUserOnboardingData,
  serviceInclinicData,
  servicePatientData,
} from "../Services/Service";
import { DateRangeComp } from "./DatePicker/CustomRangeDatePicker";
import format from "date-fns/format";
import Dropdown from "./Dropdown/Dropdown";
import StarRating from "./StarRating/StarRating";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import { set } from "date-fns";

function HomeSuperAdmin() {
  const color = ["#fa43b7", "#43c3fa"];
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({
    onboarded: 0,
    notonboarded: 0,
    total: 0,
    loggedIn: 0,
    inclinic: 0,
    completedCalls: 0,
    inactiveUsers: 0,
    firstCall: 0,
    deleteCount:0
  });
  // console.log(userData, "userData")
  const [activeCount, setActiveCount] = useState("");
  const [activeUserDetails, setActiveUserDetails] = useState([]);
  const [activeUserDetails1, setActiveUserDetails1] = useState([]);

  const [seriesGraph, setSeriesGraph] = useState({
    program_graph_series: {},
    gender_graph_series: {},
    age_graph_series: {},
    divisionCategory: [],
    divisionSeries: [],
    divisionDateCategory: [],
    divisionDateSeries: [],
    inclinicCallSeries: [],
    callDetailCategory: [],
    callDetailSeries: [],
    mesageGraphCategory: [],
    mesageGraphSeries: [],
    divisionPracticeCategory: [],
    divisionPracticeSeries: [],
    loadingStates: {
      program_graph: true,
      gender_age_graph: true,
      division_graph: true,
      division_practice_graph: true,
      division_date_graph: true,
      inclinic_call_graph: true,
      call_detail_graph: true,
      message_graph: true
    }
  });
  const [startRange, setStartRange] = useState("");
  const [endRange, setEndRange] = useState("");
  const [dateFilter, setDateFilter] = useState([]);
  const [divisionClinicFilter, setDivisionClinicFilter] = useState({
    division: [],
    clinic: [],
  });
  const [divisionPracticeData, setDivisionPracticeData] = useState([]);
  const [graphDuration, setGraphDuration] = useState("Daily ");
  const [coachRatingData, setCoachRatingData] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [programSelect, setProgramSelect] = useState("");
  const [showInclinic, setShowInclinic] = useState(0);
  const [countValue, setCountValue] = useState(false);

  var company = localStorage.getItem("company")
    ? localStorage.getItem("company")
    : 0;
  const companyId = decruptCipher(company);

  useEffect(() => {
    const performInitialEffect = async () => {
      if (companyId == 1) {
        const today = new Date();
        const startDate = new Date();
        startDate.setDate(today.getDate() - 29);
  
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };
  
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(today);
        
        setStartRange(formattedStartDate);
        setEndRange(formattedEndDate);
        
        // Create a dateFilter object that matches what DateRangeComp expects
        setDateFilter([{
          startDate: startDate,
          endDate: today,
          key: "selection"
        }]);
      }
      await filterData();
    };
  
    performInitialEffect();
  }, []);

  useEffect(() => {
    setLoading(true);

    const performFilterEffect = async () => {
      await filterData();
    };

    performFilterEffect();
    // fetchActiveUser()
  }, [startRange, endRange, divisionClinicFilter, programSelect]);

  useEffect(() => {
    fetchProgram();
    fetchDivsionPractice();
  }, []);

  let divisionArr = [];
  let clinicArr = [];
  const assignObjectPaths = (obj, stack) => {
    Object.keys(obj).forEach((k) => {
      const node = obj[k];
      if (node.type == "parent") {
        divisionArr = appendUniqueValue(divisionArr, node.value);
      }
      if (node.type == "child") {
        clinicArr = appendUniqueValue(clinicArr, node.value);
      }

      if (typeof node === "object") {
        node.path = stack ? `${stack}.${k}` : k;
        assignObjectPaths(node, node.path);
      }
    });
  };
  function appendUniqueValue(arr, value) {
    const existingIndex = arr.findIndex((item) => item === value);
    if (existingIndex !== -1) {
      arr[existingIndex] = value;
    } else {
      arr.push(value);
    }
    return arr;
  }
  const fetchDivsionPractice = async () => {
    await serviceDivisionPractice().then((res) => {
      if (res.data.code == 200) {
        assignObjectPaths(res.data.data);
        setDivisionClinicFilter((prevState) => ({
          ...prevState,
          clinic: clinicArr,
          division: divisionArr,
        }));
        setDivisionPracticeData([
          {
            label: "Select All",
            value: "toggleSelectAll",
            _toggleSelectAll: true,
            checked: true,
          },
          ...res.data.data,
        ]);
      }
    });
  };
  const fetchProgram = async () => {
    await ServiceAllprogramList().then((res) => {
      setProgramData(res.data.data);
    });
  };
  const fetchCoachRating = async () => {
    await serviceSuperviewCoachRating(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      // console.log(res.data.data);
      setCoachRatingData(res.data.data);
      // console.log(coachRatingData)
    });
  };

  const fetchActiveUser = async () => {
    await serviceSuperviewActiveUserCount(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      // console.log(res.data.data, "Active");
      setActiveCount(res.data.count);
      setActiveUserDetails(res.data.data);
    });
  };

  // const filterData = async () => {
  //   if (divisionClinicFilter.division != "" || countValue) {
  //     setCountValue(true);
  //     await fetchSuperviewUserCount();
  //     await fetchCoachRating();
  //     await fetchSuperviewUserProgramCount();
  //     await fetchActiveUser();
  //     await fetchServicePatientData();
  //     await fetchSuperviewUserDivisionCount();
  //     await fetchSuperviewUserDivisionPracticeCount();
  //     await fetchSuperviewUserDivisionDateCount();
  //     await fetchSuperviewInclinicCall();
  //     await fetchSuperviewCallDetail();
  //     await fetchSuperviewMesageGraph();
  //     //await fetchServicePatientData();
  //      setLoading(false);
  //   }
  // };

  const filterData = async () => {
    if (divisionClinicFilter.division.length > 0 || countValue) {
      setCountValue(true);
      setLoading(true); // Start loading before fetching data

      const promises = [
        fetchSuperviewUserCount(),
        fetchCoachRating(),
        fetchSuperviewUserProgramCount(),
        fetchServicePatientData(),
        fetchSuperviewUserDivisionCount(),
        fetchSuperviewUserDivisionPracticeCount(),
        fetchSuperviewUserDivisionDateCount(),
        fetchSuperviewInclinicCall(),
        fetchSuperviewCallDetail(),
        
      ];

      try {
        await Promise.all(promises); // Run all the calls in parallel
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Stop loading after all calls are done
      }
      await fetchActiveUser();
      await fetchSuperviewMesageGraph()
    }
  };

  // const filterData = async () => {
  //   if (divisionClinicFilter.division != "" || countValue) {
  //     setCountValue(true);
  //     setLoading(true);

  //     const criticalPromises = [
  //       fetchSuperviewUserCount(),
  //       fetchCoachRating(),
  //       fetchSuperviewUserProgramCount(),
  //     ];

  //     const nonCriticalPromises = [
  //       fetchActiveUser(),
  //       fetchServicePatientData(),
  //       fetchSuperviewUserDivisionCount(),
  //       fetchSuperviewUserDivisionPracticeCount(),
  //       fetchSuperviewUserDivisionDateCount(),
  //       fetchSuperviewInclinicCall(),
  //       fetchSuperviewMesageGraph(),
  //     ];

  //     try {
  //       await Promise.all(criticalPromises); // Fetch critical data first
  //       Promise.all(nonCriticalPromises).catch((err) =>
  //         console.error("Non-critical call error:", err)
  //       );
  //     } catch (error) {
  //       console.error("Error fetching critical data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  const formatter = new Intl.NumberFormat("en-IN");

  const fetchSuperviewUserCount = async () => {
    try {
    await serviceSuperviewUserCount(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      setUserData((prevState) => ({
        ...prevState,
        // onboarded: parseInt(res.data.data[0].onboardedUser),
        // total: parseInt(res.data.data[0].total),
        loggedIn: parseInt(res.data.data[0]?.loggedInUser),
        notonboarded: parseInt(res.data.data[0]?.notonboardedUser),
        inclinic: parseInt(res.data.data[0]?.inclinic),
        //completedCalls: parseInt(res.data.data[0].completedCalls),
        inactiveUsers: parseInt(res.data.data[0]?.inactiveUsers),
        firstCall: parseInt(res.data.data[0]?.firstCallUser)      }));
      setSeriesGraph((prevState) => ({
        ...prevState,
        gender_graph_series: res.data.data[0].gender_series,
        age_graph_series: res.data.data[0].age_series,
        loadingStates: {
          ...prevState.loadingStates,
          gender_age_graph: false
        }
      }));
    });
  } catch (error) {
    console.log("Error fetching user count data");
    // setSeriesGraph((prevState) => ({
    //   ...prevState,
    //   gender_graph_series: res.data.data[0].gender_series,
    //   age_graph_series: res.data.data[0].age_series,
    //   loadingStates: {
    //     ...prevState.loadingStates,
    //     gender_age_graph: false
    //   }
    // }));
  } };
  const fetchSuperviewUserProgramCount = async () => {
    try {
    await serviceSuperviewUserProgramCount(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      setSeriesGraph((prevState) => ({
        ...prevState,
        program_graph_series: res.data.data?.series || {},
        loadingStates: {
          ...prevState.loadingStates,
          program_graph: false
        }
      }));
    });
  } catch (error) {
    console.error("Error fetching program data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        program_graph: false
      }
    }));
  }
};
  const fetchSuperviewUserDivisionCount = async () => {
    try {
    await serviceSuperviewUserDivisionCount(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      setSeriesGraph((prevState) => ({
        ...prevState,
        divisionCategory: res.data.data?.category || [],
        divisionSeries: res.data.data.series || [],
        loadingStates: {
          ...prevState.loadingStates,
          division_graph: false
        }
      }));
    });
  } catch (error) {
    console.error("Error fetching division data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        division_graph: false
      }
    }));
  }
  };
  const fetchSuperviewUserDivisionPracticeCount = async () => {
    try {
    await serviceSuperviewUserDivisionPracticeCount(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      // console.log(res);
      if (res.data.status == 1) {
        setSeriesGraph((prevState) => ({
          ...prevState,
          divisionPracticeCategory: res.data.data?.category || [],
          divisionPracticeSeries: res.data.data.series || [],
        }));
      } else {
        setSeriesGraph((prevState) => ({
          ...prevState,
          divisionPracticeCategory: [],
          divisionPracticeSeries: [],
          loadingStates: {
            ...prevState.loadingStates,
            division_practice_graph: false
          }
        }));
      }
    });
  } catch (error) {
    console.error("Error fetching division practice data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      divisionPracticeCategory: [],
      divisionPracticeSeries: [],
      loadingStates: {
        ...prevState.loadingStates,
        division_practice_graph: false
      }
  }));
  }
  };
  const fetchSuperviewUserDivisionDateCount = async () => {
    try {
    await serviceSuperviewUserDivisionDateCount(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      setSeriesGraph((prevState) => ({
        ...prevState,
        divisionDateCategory: res.data.data?.category || [],
        divisionDateSeries: res.data.data.series || [],
        loadingStates: {
          ...prevState.loadingStates,
          division_date_graph: false
        }
      }));
      setGraphDuration(res.data.graphDuration);
    });
  } catch (error) {
    console.error("Error fetching division date data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        division_date_graph: false
      }
    }));
  }
  };
  const fetchSuperviewCallDetail = async () => {
    try {
    await serviceSuperviewCallDetail(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      const series = res.data.data?.series || []; // Default to an empty array if series is null/undefined
      const calldata = res.data?.callData || {}; // Default to an empty array if series is null/undefined

      console.log("callData", calldata);

      // Calculate totals from callDetailSeries if series is not empty
      // const totals = series.length
      //   ? series.reduce((acc, item) => {
      //       acc[item.name.toLowerCase()] = item.data.reduce(
      //         (sum, value) => sum + value,
      //         0
      //       );
      //       return acc;
      //     }, {})
      //   : {};

      // const formatter = new Intl.NumberFormat("en-IN");
      // const scheduledCalls = Object.values(totals).reduce(
      //   (sum, value) => sum + value,
      //   0
      // );

      // setUserData((prevState) => ({
      //   ...prevState,
      //   incompleteCalls: formatter.format(totals.incomplete || 0),
      //   completedCalls: formatter.format(totals.completed || 0),
      //   missedCalls: formatter.format(totals.missed || 0),
      //   cancelledCalls: formatter.format(totals.cancelled || 0),
      //   unsuccessfulCalls: formatter.format(totals.unsuccessful || 0),
      //   scheduledCalls: 100 //formatter.format(scheduledCalls),
      // }));

      setUserData((prevState) => ({
        ...prevState,
        incompleteCalls: formatter.format(calldata.incomplete || 0),
        completedCalls: formatter.format(calldata.completed || 0),
        missedCalls: formatter.format(calldata.missed || 0),
        cancelledCalls: formatter.format(calldata.cancelled || 0),
        unsuccessfulCalls: formatter.format(calldata.unsuccessfull || 0),
        scheduledCalls: formatter.format(calldata.scheduled),
      }));

      setSeriesGraph((prevState) => ({
        ...prevState,
        callDetailCategory: res.data.data?.category || [], // Handle empty category
        callDetailSeries: series, // Use the (possibly empty) series array
        loadingStates: {
          ...prevState.loadingStates,
          call_detail_graph: false
        }
      }));

      setGraphDuration(res.data.graphDuration || null); // Default to null if not present
    });
  } catch (error) {
    console.error("Error fetching call detail data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        call_detail_graph: false
      }
    }));
  }
  };
  const fetchSuperviewMesageGraph = async () => {
    try {
    await serviceSuperviewMesageGraph(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      const series = res.data.data?.series;
      const formatter = new Intl.NumberFormat("en-IN");
      // Calculate totals from mesageGraphSeries
      const messageTotals = series
        ? series.reduce((acc, item) => {
            acc[item.name.toLowerCase()] = item.data.reduce(
              (sum, value) => sum + value,
              0
            );
            return acc;
          }, {})
        : {};

      // Calculate the total of all messages
      const totalMessages = Object.values(messageTotals).reduce(
        (sum, value) => sum + value,
        0
      );

      setUserData((prevState) => ({
        ...prevState,
        coachSentUserReceived: formatter.format(
          messageTotals["coach sent/user received"] || 0
        ),
        userSentCoachReceived: formatter.format(
          messageTotals["user sent/coach received"] || 0
        ),
        expertSentPlayerReceived: formatter.format(
          messageTotals["expert sent/player received"] || 0
        ),
        totalMessages: formatter.format(totalMessages), // Add the total of all messages
      }));
      setSeriesGraph((prevState) => ({
        ...prevState,
        mesageGraphCategory: res.data.data?.category || [],
        mesageGraphSeries: res.data.data?.series || [],
        loadingStates: {
          ...prevState.loadingStates,
          message_graph: false
        }
      }));
      setGraphDuration(res.data.graphDuration);
    });
  } catch (error) {
    console.error("Error fetching message data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        message_graph: false
      }
    }));
  }
  };
  const fetchSuperviewInclinicCall = async () => {
    try {
    await serviceSuperviewInclinicCall(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      setShowInclinic(res.data.status);
      if (res.data.status == 1) {
        setSeriesGraph((prevState) => ({
          ...prevState,
          inclinicCallSeries: res.data.data.series || [],
          loadingStates: {
            ...prevState.loadingStates,
            inclinic_call_graph: false
          }
        }));

        // Extract the count of "completed"
        const completedCount =
          res.data.data.series.data.find(
            (item) => item[0] === "completed"
          )?.[1] || 0; // Fallback to 0 if not found
        // const scheduledCount = res.data.data.series.data.find(
        //   (item) => item[0] === "scheduled"
        // )?.[1] || 0; // Fallback to 0 if not found
        const totalCount = res.data.data.series.data.reduce(
          (sum, item) => sum + (item[1] || 0),
          0
        );
        setUserData((prevState) => ({
          ...prevState,
          completedInClinicCount: completedCount,
          scheduledInClinicCount: totalCount,
        }));
        // console.log("Count of completed:", completedCount);
        // You can now use `completedCount` as needed
      }
    });
  } catch (error) {
    console.error("Error fetching inclinic call data:", error);
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        inclinic_call_graph: false
      }
    }));
  }
  };
  const fetchServicePatientData = async () => {
    try {
    await servicePatientData(
      startRange,
      endRange,
      divisionClinicFilter,
      programSelect
    ).then((res) => {
      // console.log(res.data.data, "patient data")
      setUserData((prevState) => ({
        ...prevState,
        notLogin: res.data.data?.notLogin ?? 0,
        partialOnboard: res.data.data?.partialOnboard ?? 0,
        onboarded: res.data.data?.onboarded ?? 0,
        total: res.data.data?.total ?? 0,
        deleteCount: res.data.data?.deleteCount ?? 0,

      }));
    });
  }
  catch (error) {
    console.error("Error fetching patient data:", error);
  }
  };
  const getData = (data) => {
    // Make sure data contains valid dates before updating
    if (data && data.length > 0 && data[0].startDate && data[0].endDate) {
      let start = format(data[0].startDate, "yyyy-MM-dd");
      let end = format(data[0].endDate, "yyyy-MM-dd");
      setStartRange(start);
      setEndRange(end);
    }
  };

  // const handleExport = async () => {
  //   const current = new Date();
  //   const date = `${current.getDate()}/${current.getMonth() + 1
  //     }/${current.getFullYear()}, ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
  //   var wb = XLSX.utils.book_new();

  //   try {
  //     const res = await getInactiveUserExport();
  //     let exportData = res.data.data;

  //     var ws = XLSX.utils.json_to_sheet(exportData);
  //     XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  //     const csvName = "Inactive";
  //     XLSX.writeFile(wb, `${csvName} ${date}.csv`);
  //   } catch (error) {
  //     console.error("Error exporting data:", error);
  //   }
  // };

  const updateParentChildDropdown = (index, checkedValue, type, childindex) => {
    if (type == "parent") {
      const chld = divisionPracticeData[index].children.map((child) => {
        // return child.value ;
        if (checkedValue) {
          setDivisionClinicFilter((prevState) => ({
            ...prevState,
            clinic: [...prevState.clinic, child.value],
          }));
        } else {
          setDivisionClinicFilter((prevState) => {
            const updatedClinic = prevState.clinic.filter(
              (d) => d !== child.value
            );
            return { ...prevState, clinic: updatedClinic };
          });
        }
      });
      // console.log(chld);

      const updatedData = divisionPracticeData.map((parent, parentIndex) => {
        if (parentIndex == index) {
          const updatedChildren = parent.children.map((child) => ({
            ...child,
            checked: checkedValue,
          }));

          return {
            ...parent,
            checked: checkedValue,
            expanded: false,
            children: updatedChildren,
          };
        } else {
          return {
            ...parent,
            expanded: false,
          };
        }

        // return parent;
      });
      // console.log(updatedData, "updatedData")
      setDivisionPracticeData(updatedData); // Update the state with the modified array
    } else {
      if (type == "child") {
        const updatedData = [...divisionPracticeData]; // Create a copy of the original data
        updatedData[index].children[childindex].checked = checkedValue;

        const allChecked = updatedData[index].children.every(
          (child) => child.checked
        );
        const allUnchecked = updatedData[index].children.every(
          (child) => !child.checked
        );
        const atLeastOneChecked = updatedData[index].children.some(
          (child) => child.checked
        );
        const atLeastOneUnchecked = updatedData[index].children.some(
          (child) => !child.checked
        );
        // console.log("allChecked", allChecked);
        // console.log("allUnchecked", allUnchecked);
        // console.log("atLeastOneChecked", atLeastOneChecked);
        // console.log("atLeastOneUnchecked", atLeastOneUnchecked);

        const uncheckedChild = updatedData[index].children.find(
          (child) => !child.checked
        );
        const allChildrenUnchecked = updatedData[index].children.every(
          (child) => !child.checked
        );
        // console.log("allChildrenUnchecked==",allChildrenUnchecked);
        if (atLeastOneChecked) {
          pushToDivision(updatedData[index].value);
        }
        if (allChildrenUnchecked) {
          setDivisionClinicFilter((prevState) => {
            const updatedDivision = prevState.division.filter(
              (d) => d !== updatedData[index].value
            );
            return { ...prevState, division: updatedDivision };
          });
        }
        if (uncheckedChild) {
          //mark parent
          updatedData[index].checked = false;
        } else {
          updatedData[index].checked = true;
        }
        // updatedData[index].expanded = true;
        const updatedData1 = updatedData.map((item, i) => {
          if (index == i) {
            // Skip updating 'expanded' for key 3 node (index 2)
            return { ...item, expanded: true };
          } else {
            return { ...item, expanded: false };
          }
        });

        setDivisionPracticeData(updatedData1);
      }
    }
  };
  // const updateParentChildDropdown = (index, checkedValue, type, childindex) => {
  //   const updatedData = [...divisionPracticeData]; // Create a copy of the original data
  //   console.log(type, "type")
  //   console.log(checkedValue, "checkedValue")
  //   if (type === "parent") {
  //     const updatedChildren = updatedData[index].children.map((child) => ({
  //       ...child,
  //       checked: checkedValue,
  //     }));
  //     console.log(updatedChildren, "updatedChildren")

  //     updatedData[index].checked = checkedValue;
  //     updatedData[index].children = updatedChildren;

  //     // Update clinic filter based on checked parent (only add checked children)
  //     updatedChildren.forEach((child) => {
  //       if (checkedValue && child.checked) {
  //         setDivisionClinicFilter((prevState) => ({
  //           ...prevState,
  //           clinic: [...prevState.clinic, child.value], // Add only checked children
  //         }));
  //       }
  //     });
  //     console.log(updatedData, "updatedData")
  //     // Set the updated data back
  //     setDivisionPracticeData(updatedData);
  //   } else if (type === "child") {
  //     updatedData[index].children[childindex].checked = checkedValue;

  //     // Update parent based on child selection (check if all children are checked)
  //     const allChecked = updatedData[index].children.every((child) => child.checked);
  //     updatedData[index].checked = allChecked;

  //     // Update clinic filter (add or remove only checked children)
  //     if (checkedValue) {
  //       setDivisionClinicFilter((prevState) => ({
  //         ...prevState,
  //         clinic: [...prevState.clinic, updatedData[index].children[childindex].value], // Add checked child
  //       }));
  //     } else {
  //       setDivisionClinicFilter((prevState) => {
  //         const updatedClinic = prevState.clinic.filter(
  //           (d) => d !== updatedData[index].children[childindex].value // Remove unchecked child
  //         );
  //         return { ...prevState, clinic: updatedClinic };
  //       });
  //     }

  //     // Handle division filter if all children are unchecked
  //     if (updatedData[index].children.every((child) => !child.checked)) {
  //       setDivisionClinicFilter((prevState) => {
  //         const updatedDivision = prevState.division.filter(
  //           (d) => d !== updatedData[index].value // Remove division if no child is selected
  //         );
  //         return { ...prevState, division: updatedDivision };
  //       });
  //     }
  //     console.log(updatedData, "updatedData")
  //     // Set the updated data back
  //     setDivisionPracticeData(updatedData);
  //   }
  // };

  // console.log(divisionPracticeData, "divisionPracticeData")

  const pushToDivision = (value) => {
    setDivisionClinicFilter((prevState) => {
      if (!prevState.division.includes(value)) {
        return {
          ...prevState,
          division: [...prevState.division, value],
        };
      }
      return prevState;
    });
  };
  // const getDropdownData = (currentNodeLabel, currentNode) => {
  //   const currentVal = currentNode.value;
  //   const currentPath = currentNode.path;

  //   if (currentNodeLabel == "parent") {
  //     if (currentNode.checked) {
  //       updateParentChildDropdown(currentPath, true, "parent", "");
  //       pushToDivision(currentVal);
  //     } else {
  //       updateParentChildDropdown(currentPath, false, "parent", "");
  //       setDivisionClinicFilter((prevState) => {
  //         const updatedDivision = prevState.division.filter(
  //           (d) => d !== currentVal
  //         );
  //         return { ...prevState, division: updatedDivision };
  //       });
  //     }
  //   }

  //   if (currentNodeLabel == "child") {
  //     let pathSplit = currentPath.split(".");
  //     let parentKey = pathSplit[0];
  //     let childKey = pathSplit[2];
  //     if (currentNode.checked) {
  //       updateParentChildDropdown(parentKey, true, "child", childKey);
  //       setDivisionClinicFilter((prevState) => ({
  //         ...prevState,
  //         clinic: [...prevState.clinic, currentVal],
  //       }));
  //     } else {
  //       updateParentChildDropdown(parentKey, false, "child", childKey);
  //       setDivisionClinicFilter((prevState) => {
  //         const updatedClinic = prevState.clinic.filter(
  //           (d) => d !== currentVal
  //         );
  //         return { ...prevState, clinic: updatedClinic };
  //       });
  //     }
  //   }
  // };

  // const getDropdownData = (currentNodeLabel, currentNode) => {
  //   const currentVal = currentNode.value;
  //   const currentPath = currentNode.path;

  //   // console.log(currentNodeLabel, "currentNodeLabel")
  //   // console.log(currentNode, "currentNode")

  //   if (currentNodeLabel === "parent") {
  //     if (currentNode.checked) {
  //       updateParentChildDropdown(currentPath, true, "parent", "");
  //       pushToDivision(currentVal);
  //     } else {
  //       updateParentChildDropdown(currentPath, false, "parent", "");
  //       setDivisionClinicFilter((prevState) => {
  //         const updatedDivision = prevState.division.filter(
  //           (d) => d !== currentVal
  //         );
  //         return { ...prevState, division: updatedDivision };
  //       });
  //     }
  //   }

  //   if (currentNodeLabel === "child") {
  //     let pathSplit = currentPath.split(".");
  //     let parentKey = pathSplit[0];
  //     let childKey = pathSplit[2];

  //     if (currentNode.checked) {
  //       updateParentChildDropdown(parentKey, true, "child", childKey);
  //       setDivisionClinicFilter((prevState) => ({
  //         ...prevState,
  //         clinic: [...prevState.clinic, currentVal],
  //       }));
  //     } else {
  //       updateParentChildDropdown(parentKey, false, "child", childKey);
  //       setDivisionClinicFilter((prevState) => {
  //         const updatedClinic = prevState.clinic.filter(
  //           (d) => d !== currentVal
  //         );
  //         return { ...prevState, clinic: updatedClinic };
  //       });
  //     }
  //   }
  // };

  const handleDropDownChange = (currentNode) => {
    let divisionsArray = [...divisionClinicFilter.division];
    let clinicArray = [...divisionClinicFilter.clinic];

    if (currentNode._toggleSelectAll) {
      setDivisionPracticeData((prevState) => {
        if (!currentNode.checked) {
          clinicArray = [];
          divisionsArray = [];
        }
        return prevState.map((data, index) => {
          let updatedData = [];
          if (currentNode.checked && index !== 0) {
            divisionsArray.push(data.value);
          }
          if (data.children) {
            updatedData = data.children.map((child) => {
              currentNode.checked && clinicArray.push(child.value);
              return {
                ...child,
                checked: currentNode.checked,
              };
            });
            return {
              ...data,
              checked: currentNode.checked,
              children: updatedData,
            };
          } else {
            return { ...data, checked: currentNode.checked };
          }
        });
      });
    } else if (currentNode.type === "child") {
      if (currentNode.checked) {
        clinicArray.push(currentNode.value);
      } else {
        clinicArray = clinicArray.filter((data) => data !== currentNode.value);
      }

      let pathSplit = currentNode.path.split(".");
      let parentKey = pathSplit[0];
      let childKey = pathSplit[2];

      setDivisionPracticeData((prevState) => {
        return prevState.map((data, ind) => {
          let updatedData;
          if (ind === Number(parentKey) + 1) {
            divisionsArray.push(data.value);
            updatedData = data?.children?.map((child, childInd) => {
              if (childInd === Number(childKey)) {
                return { ...child, checked: currentNode.checked };
              } else {
                return child;
              }
            });

            return {
              ...data,
              children: updatedData,
            };
          } else {
            return data;
          }
        });
      });
    } else {
      divisionsArray.push(currentNode.value);

      setDivisionPracticeData((prevState) => {
        return prevState.map((data) => {
          if (data.value === currentNode.value) {
            let updatedData;
            if (data.children) {
              updatedData = data.children.map((child) => {
                if (currentNode.checked) {
                  clinicArray.push(child.value);
                } else {
                  clinicArray = clinicArray.filter(
                    (data) => data !== child.value
                  );
                }

                return {
                  ...child,
                  checked: currentNode.checked,
                };
              });
              return {
                ...data,
                checked: currentNode.checked,
                children: updatedData,
              };
            } else {
              return { ...data, checked: currentNode.checked };
            }
          } else {
            return data;
          }
        });
      });
    }

    setTimeout(() => {
      setDivisionClinicFilter({
        division: divisionsArray,
        clinic: clinicArray,
      });
    }, 0);
  };

  const nodeToggle = (cuurentNode) => {
    setDivisionPracticeData((prevState) => {
      return prevState.map((data) => {
        if (data.value === cuurentNode.value) {
          return {
            ...data,
            expanded: data.expanded ? false : true,
          };
        } else {
          return data;
        }
      });
    });
  };

  const handleProgramChange = (event) => {
    setProgramSelect(event.target.value);
  };

  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState([]);
  // Function to handle title change

  const updateModalTitle = async (title) => {
    // console.log(title, "title")
    setModalContent([]);
    setCsvData([]);
    setModalTitle(title);
    if (title == "Active Patients") {
      await serviceSuperviewActiveUserCount(
        startRange,
        endRange,
        divisionClinicFilter,
        programSelect,
        "Y"
      ).then((res) => {
        setModalContent(res.data.data);
        setActiveUserDetails1(res.data.data)
      });
    } else if (
      title == "Messages from Coach to Patient" ||
      title == "Messages from Patient to Coach"
    ) {
      let selection =
        title == "Messages from Coach to Patient"
          ? "coachPatient"
          : "patientCoach";
      await serviceMessageData(
        startRange,
        endRange,
        selection,
        divisionClinicFilter,
        programSelect
      ).then((res) => {
        // console.log(res.data.data, "reached")
        setModalContent(res.data.data);
      });
    } else if (
      title == "Scheduled Calls" ||
      title == "Completed Calls" ||
      title == "Incomplete Calls" ||
      title == "Missed Calls" ||
      title == "Cancelled Calls" ||
      title == "Unsuccessful Calls"
    ) {
      let selection = title;
      await serviceCallData(
        startRange,
        endRange,
        selection,
        divisionClinicFilter,
        programSelect
      ).then((res) => {
        // console.log(res.data.data, "reached")
        setModalContent(res.data.data);
      });
    } else if (
      title == "Partially Registered Patients" ||
      title == "Fully Onboarded Patients" ||
      title == "Accounts Created" ||
      title == "In-Active Patients"
    ) {
      let selection = title;
      await serviceUserOnboardingData(
        startRange,
        endRange,
        selection,
        divisionClinicFilter,
        programSelect
      ).then((res) => {
        // console.log(res.data.data, "reached")
        setModalContent(res.data.data);
      });
    } else if (
      title == "Scheduled In-Clinic Appointments" ||
      title == "Completed In-Clinic Appointments"
    ) {
      let selection = title;
      await serviceInclinicData(
        startRange,
        endRange,
        selection,
        divisionClinicFilter,
        programSelect
      ).then((res) => {
        // console.log(res.data.data, "reached")
        setModalContent(res.data.data);
      });
    }
    setShowExportButton(true);
      
  };

  // console.log(modalContent, "modalContent")

  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedContent, setPaginatedContent] = useState([]);
  const itemsPerPage = 5; // Number of rows per page

  // Calculate the total number of pages
  const totalPages = Math.ceil(modalContent.length / itemsPerPage);

  // Update paginated content whenever modalContent or currentPage changes
  useEffect(() => {
    if (modalContent && modalContent.length > 0) {
      const updatedPaginatedContent = modalContent.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );
      setPaginatedContent(updatedPaginatedContent);
    } else {
      setPaginatedContent([]);
    }
  }, [modalContent, currentPage]);

  // Handle Next and Previous
  const handleNext = () => {
    // console.log(currentPage, "currentPage")
    // console.log(totalPages, "totalPages")
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const [csvData, setCsvData] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);

  // const handleExport = async () => {
  //   setLoadingExport(true);
  //   const data = await fetchExportData();
  //   setCsvData(data);
  //   setLoadingExport(false);
  // };

  // Prepare data for CSV export
  // const activePatientsHeaders = [
  //   { label: "Patient Name", key: "patient_name" },
  //   { label: "NHS ID", key: "NHS_Id" },
  //   { label: "Mobile Number", key: "mobile" },
  //   { label: "Program Name", key: "program_names" },
  //   { label: "SMS Sent Date", key: "smssentdate" },
  //   { label: "SMS Delivered Date", key: "smsdeliverdate" },
  // ];

  // const activePatientsData = modalContent.map((item) => ({
  //   patient_name: item.patient_name,
  //   NHS_Id: item.NHS_Id,
  //   mobile: item.mobile,
  //   program_names: item.program_names,
  //   smssentdate: new Date(item.smssentdate).toLocaleDateString("en-GB"),
  //   smsdeliverdate: new Date(item.smsdeliverdate).toLocaleDateString("en-GB"),
  // }));

  // const conversationHeaders = [
  //   { label: "Year", key: "Year" },
  //   { label: "Month/Date", key: "MonthOrDay" },
  //   { label: "Conversation Count", key: "total_conversations" },
  // ];

  // const conversationData = modalContent.map((item) => ({
  //   Year: item.Year || item.Day, // Use Year or Day based on available data
  //   MonthOrDay: item.Month || item.Day, // Use Month or Day based on available data
  //   total_conversations: item.total_conversations,
  // }));

  // // Decide headers and data based on modalTitle
  // const csvHeaders =
  //   modalTitle === "Active Patients" ? activePatientsHeaders : conversationHeaders;

  // // const csvData =
  //   modalTitle === "Active Patients" ? activePatientsData : conversationData;

  const handleModalClose = () => {
    setCurrentPage(1); // Reset pagination to the first page
    // Add other close logic if necessary, such as hiding the modal
  };
  const [showExportButton, setShowExportButton] = useState(true);

  const fetchExportData = async () => {
    try {
      //alert("HEREE");
      setLoadingExport(true);
      setCsvData([]);
      //alert("cec");
      // Set the selection based on modalTitle
      const selection = modalTitle;

      //alert(modalTitle);

      // Call the service to fetch export data
      const response = await serviceExportData(
        startRange,
        endRange,
        selection,
        divisionClinicFilter,
        programSelect
      );

      // Extract the relevant data from the API response
      const data = response?.data?.data || [];
      // console.log(data, "data")
      // console.log(modalTitle, "modalTitle")
      // Process and transform the data for export
      console.log("activeUserDetails",activeUserDetails1);
      const exportData =
        modalTitle === "Active Patients"
          ? activeUserDetails1.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.NHS_Id,
              mobile: item.mobile,
              program_names: item.program_names,
              smssentdate:
                !item.smssentdate ||
                item.smssentdate === "0000-00-00 00:00:00" ||
                isNaN(new Date(item.smssentdate).getTime())
                  ? "-"
                  : new Date(item.smssentdate).toLocaleDateString("en-GB"),
              smsdeliverdate:
                !item.smsdeliverdate ||
                item.smsdeliverdate === "0000-00-00 00:00:00" ||
                isNaN(new Date(item.smsdeliverdate).getTime())
                  ? "-"
                  : new Date(item.smsdeliverdate).toLocaleDateString("en-GB"),
            }))
          : modalTitle === "Fully Onboarded Patients"
          ? modalContent.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              program_names: item.program_names,
              smssentdate: new Date(item.smssentdate).toLocaleDateString(
                "en-GB"
              ),
              smsdeliverdate: new Date(item.smsdeliverdate).toLocaleDateString(
                "en-GB"
              ),
              loggedindate: new Date(item.loginDate).toLocaleDateString(
                "en-GB"
              ),
              onboardingdate: new Date(item.onboarding_date).toLocaleDateString(
                "en-GB"
              ),
            }))
          : modalTitle === "Accounts Created"
          ? modalContent.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              program_names: item.program_names,
              smssentdate:
                !item.smssentdate ||
                item.smssentdate === "0000-00-00 00:00:00" ||
                isNaN(new Date(item.smssentdate).getTime())
                  ? "-"
                  : new Date(item.smssentdate).toLocaleDateString("en-GB"),

              smsdeliverdate:
                !item.smsdeliverdate ||
                item.smsdeliverdate === "0000-00-00 00:00:00" ||
                isNaN(new Date(item.smsdeliverdate).getTime())
                  ? "-"
                  : new Date(item.smsdeliverdate).toLocaleDateString("en-GB"),
              onboardingdate:
                !item.onboarding_date ||
                item.onboarding_date === "0000-00-00 00:00:00" ||
                isNaN(new Date(item.onboarding_date).getTime())
                  ? "-"
                  : new Date(item.onboarding_date).toLocaleDateString("en-GB"),
            }))
          : modalTitle === "In-Active Patients"
          ? modalContent.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              program_names: item.program_names,
              onboardingdate: new Date(item.onboarding_date).toLocaleDateString(
                "en-GB"
              ),
            }))
          : modalTitle === "Partially Registered Patients"
          ? modalContent.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              program_names: item.program_names,
              smssentdate: new Date(item.smssentdate).toLocaleDateString(
                "en-GB"
              ),
              smsdeliverdate: new Date(item.smsdeliverdate).toLocaleDateString(
                "en-GB"
              ),
              loggedindate: new Date(item.loginDate).toLocaleDateString(
                "en-GB"
              ),
            }))
          : modalTitle === "Scheduled In-Clinic Appointments"
          ? data.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              appointment_scheduled_on: new Date(
                item.appointment_scheduled_on
              ).toLocaleDateString("en-GB"),
              appointment_scheduled_on: new Date(
                item.appointment_scheduled_on
              ).toLocaleDateString("en-GB"),
              appointment_status: item.appointment_status,
              cnt: item.cnt,
            }))
          : modalTitle === "Completed In-Clinic Appointments"
          ? data.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              appointment_scheduled_on: new Date(
                item.appointment_scheduled_on
              ).toLocaleDateString("en-GB"),
              appointment_scheduled_on: new Date(
                item.appointment_scheduled_on
              ).toLocaleDateString("en-GB"),
              appointment_status: item.appointment_status,
              appointment_completed_on: new Date(
                item.appointment_completed_on
              ).toLocaleDateString("en-GB"),
              cnt: item.cnt,
            }))
          : modalTitle === "Messages from Patient to Coach"
          ? data.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              coachname: item.coachname,
              cnt: item.cnt,
            }))
          : modalTitle === "Messages from Coach to Patient"
          ? data.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              coachname: item.coachname,
              cnt: item.cnt,
            }))
          : data.map((item) => ({
              patient_name: item.patient_name,
              NHS_Id: item.nhsNumber,
              mobile: item.mobile,
              total_conversations: item.cnt,
            }));

      console.log(exportData, "exportData");

      setCsvData(exportData);
      setShowExportButton(false);
      // setTimeout(() => {
      //   document.getElementById("csv-link").click();
      // }, 1000);
      // document.getElementById("csv-link").click();
    } catch (error) {
      console.error("Error fetching export data:", error);
      return [];
    } finally {
      setLoadingExport(false);
    }
  };

  console.log(modalTitle, "modalTitle");

  const headersMap = {
    "Active Patients": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Program Name", key: "program_names" },
      { label: "SMS Sent Date", key: "smssentdate" },
      { label: "SMS Delivered Date", key: "smsdeliverdate" },
    ],
    "Fully Onboarded Patients": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Program Name", key: "program_names" },
      { label: "Logged In Date", key: "loggedindate" },
      { label: "Onboarding Date", key: "onboardingdate" },
    ],
    "Partially Registered Patients": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Program Name", key: "program_names" },
      { label: "Logged In Date", key: "loggedindate" },
    ],
    "Scheduled In-Clinic Appointments": [
      { label: "Patient Name", key: "patient_name" },
      // { label: "NHS ID", key: "NHS_Id" },
      // { label: "Mobile Number", key: "mobile" },
      { label: "Date Appointment Booked on", key: "appointment_scheduled_on" },
      { label: "Appointment Date", key: "appointment_scheduled_on" },
      { label: "Appointment Status", key: "appointment_status" },
      { label: "Count of calls", key: "cnt" },
    ],
    "Completed In-Clinic Appointments": [
      { label: "Patient Name", key: "patient_name" },
      // { label: "NHS ID", key: "NHS_Id" },
      // { label: "Mobile Number", key: "mobile" },
      { label: "Date Appointment Booked on", key: "appointment_scheduled_on" },
      { label: "Appointment Date", key: "appointment_scheduled_on" },
      { label: "Appointment Status", key: "appointment_status" },
      { label: "Date of Completion", key: "appointment_completed_on" },
      { label: "Count of calls", key: "cnt" },
    ],
    "Messages from Coach to Patient": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Coach Name", key: "coachname" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Count of Coach messages", key: "cnt" },
    ],
    "Messages from Patient to Coach": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Coach Name", key: "coachname" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Count of Patient messages", key: "cnt" },
    ],
    "In-Active Patients": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Program Name", key: "program_names" },
      { label: "Onboarding Date", key: "onboardingdate" },
    ],
    "Accounts Created": [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Program Name", key: "program_names" },
      { label: "Onboarding Date", key: "onboardingdate" },
      { label: "SMS Sent Date", key: "smssentdate" },
      { label: "SMS Delivered Date", key: "smsdeliverdate" },
    ],
    default: [
      { label: "Patient Name", key: "patient_name" },
      { label: "NHS ID", key: "NHS_Id" },
      { label: "Mobile Number", key: "mobile" },
      { label: "Conversation Count", key: "total_conversations" },
    ],
  };
  const headers = headersMap[modalTitle] || headersMap.default;

  const clearForm = ()=>{ 
    setLoading(true);    
    console.log('click')         
    if(!loading){      
      setTimeout(()=>{
         setLoading(true);  
        setStartRange("");
        setEndRange("");
        setDateFilter([{
          startDate: null,
          endDate: null,
          key: "selection"
        }]);
        fetchDivsionPractice();
        setDivisionClinicFilter({ division: [], clinic: [] });
      },500)
    }  
  }


  return (
    <>
      <section className="projects-section">
        <div className="row">
          <div className="col-md">
            <h1 className="title">Super Admin Overview</h1>
          </div>
          <div className="col-md-2 pe-1">
            <select
              id="programSelect"
              name="programSelect"
              value={programSelect}
              className="form-select form-select-sm"
              required
              onChange={(event) => handleProgramChange(event)}
            >
              <option value="">Select Program</option>

              {programData?.length > 0
                ? programData.map((data, i) => (
                    <option value={data.programId} key={i}>
                      {data.programName}
                    </option>
                  ))
                : null}
            </select>
          </div>
          <div className="col-md-2 pe-0">
            <Dropdown
              data={divisionPracticeData}
              onChange={handleDropDownChange}
              nodeToggle={nodeToggle}
            />
          </div>
          <div className="col-md-auto pe-1">
          <DateRangeComp
            typeofdate="blank"
            filterParam={{ 
              smsStartFilter: startRange, 
              smsEndFilter: endRange 
            }}
            dateFilter={dateFilter}
            onClick={getData}
          />
          </div>
          <div className="col-md-auto ps-0">
          <button
              type="button"
              disabled={loading}
              className="btn btn-success btn-sm"
              onClick={clearForm}
            >
              Clear
            </button>
            &nbsp;&nbsp;
            {/* <button onClick={handleExport} className="btn btn-success btn-sm r-2">EXPORT</button> */}
          </div>
        </div>

        <div className="row mb-10 px-2">
          {/* <div className="col-6 col-md-2 mt-3">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/88760_1681801347.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.onboarded}</h1>
                        <h2 className='subtitle'>Total Active Users</h2>
                    </div>
                </div> */}

          {/* <div className="col-6 col-md-2 mt-3">
                    <div className='superadminbox'>
                        <img src="https://appcdn.goqii.com/storeimg/24762_1681803043.png" alt="" className='imgicon mb-2' />
                        <h1 className='titlenumbers'>{userData.onboarded + userData.notonboarded}</h1>
                        <h2 className='subtitle'>Uploaded Users</h2>
                    </div>
                </div> */}

          <div className="col-12 col-md-12 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Active Patients")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/93035_1684235616.png"
                alt=""
                className="imgicon mb-2"
              />
              {/* <h1 className="titlenumbers"> {userData.total - userData.loggedIn}</h1> */}
              <h1 className="titlenumbers">
            {activeCount ? activeCount : 0}
          </h1>
              <h2 className="subtitle">Active Patients</h2>
            </a>
          </div>
          <div className="col-12 px-3">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1">
                <a
                  className="superadminboxN"
                  data-bs-toggle="modal"
                  data-bs-target="#superAdminModal"
                  onClick={() => updateModalTitle("Accounts Created")}
                >
                  <img
                    src="https://appcdn.goqii.com/storeimg/13688_1684235547.png"
                    alt=""
                    className="imgicon mb-2"
                  />
                  <h1 className="titlenumbers">{userData.total ? userData.total : 0}</h1>
                  <h2 className="subtitle">Accounts Created</h2>
                </a>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1">
                <div
                  className="superadminboxN"
                  data-bs-toggle="modal"
                  data-bs-target="#superAdminModal"
                  onClick={() =>
                    updateModalTitle("Partially Registered Patients")
                  }
                >
                  <img
                    src="https://appcdn.goqii.com/storeimg/59789_1681803187.png"
                    alt=""
                    className="imgicon mb-2"
                  />
                  <h1 className="titlenumbers">{userData.partialOnboard ? userData.partialOnboard : 0}</h1>
                  <h2 className="subtitle">Partially Registered Patients</h2>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1">
                <a
                  className="superadminboxN"
                  data-bs-toggle="modal"
                  data-bs-target="#superAdminModal"
                  onClick={() => updateModalTitle("Fully Onboarded Patients")}
                >
                  <img
                    src="https://appcdn.goqii.com/storeimg/88760_1681801347.png"
                    alt=""
                    className="imgicon mb-2"
                  />
                  <h1 className="titlenumbers">{userData.onboarded ? userData.onboarded : 0}</h1>
                  <h2 className="subtitle">Fully Onboarded Patients</h2>
                </a>
              </div>

              {companyId == 1 || companyId == 3 ? (
                <div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1">
                  <a
                    className="superadminboxN"
                    data-bs-toggle="modal"
                    data-bs-target="#superAdminModal"
                    onClick={() => updateModalTitle("In-Active Patients")}
                  >
                    <img
                      src="https://appcdn.goqii.com/storeimg/58427_1709296358.png"
                      alt=""
                      className="imgicon mb-2"
                    />
                    {/* <h1 className="titlenumbers">{userData.total - userData.loggedIn}</h1> */}
                    <h1 className="titlenumbers">{userData.notLogin ? userData.notLogin : 0}</h1>
                    <h2 className="subtitle">
                      {companyId == 1 || companyId == 3 ? (
                        <span> In-Active Patients</span>
                      ) : (
                        "Discharged Patients"
                      )}
                    </h2>
                  </a>
                </div>
              ) : (
                <>
                  {companyId == 2 ? (
                    <>
                      <div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1">
                        <a
                          className="superadminboxN"
                          data-bs-toggle="modal"
                          data-bs-target="#superAdminModal"
                          onClick={() => updateModalTitle("First consultation")}
                        >
                          <img
                            src="https://appcdn.goqii.com/storeimg/76526_1681803201.png"
                            alt=""
                            className="imgicon mb-2"
                          />
                          <h1 className="titlenumbers">{userData.firstCall ? userData.firstCall : 0}</h1>
                          <h2 className="subtitle">First consultation</h2>
                        </a>
                      </div>

                      <div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1">
                        <a
                          className="superadminboxN"
                          data-bs-toggle="modal"
                          data-bs-target="#superAdminModal"
                          onClick={() => updateModalTitle("In-Active Patients")}
                        >
                          <img
                            src="https://appcdn.goqii.com/storeimg/58427_1709296358.png"
                            alt=""
                            className="imgicon mb-2"
                          />
                          <h1 className="titlenumbers">
                            {userData.inactiveUsers ? userData.inactiveUsers : 0}
                          </h1>
                          <h2 className="subtitle">
                            {companyId == 1 ? (
                              <span> In-Active Patients</span>
                            ) : (
                              "Discharged Patients"
                            )}
                          </h2>
                        </a>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}

<div className="col-12 col-sm-6 col-md-4 col-lg col-xl mt-3 px-1 superadminboxN">
                  <img
                    src="https://appcdn.goqii.com/storeimg/88760_1681801347.png"
                    alt=""
                    className="imgicon mb-2"
                  />
                  <h1 className="titlenumbers">{userData.deleteCount ? userData.deleteCount : 0}</h1>
                  <h2 className="subtitle">Deleted Patients</h2>
              </div>

            </div>
          </div>

          {/* line-r style={{borderRight: '1px solid rgb(181 181 181)' }} */}

          {companyId == 1 ? (
            <div className="col-6 col-md-6 mt-3 px-1">
              <div
                className="superadminboxN"
                data-bs-toggle="modal"
                data-bs-target="#superAdminModal"
                onClick={() =>
                  updateModalTitle("Scheduled In-Clinic Appointments")
                }
              >
                <img
                  src="https://appcdn.goqii.com/storeimg/76526_1681803201.png"
                  alt=""
                  className="imgicon mb-2"
                />
                <h1 className="titlenumbers">
                  {userData.scheduledInClinicCount ? userData.scheduledInClinicCount : 0}
                </h1>
                <h2 className="subtitle">Scheduled In-Clinic Appointments </h2>
              </div>
            </div>
          ) : (
            ""
          )}

          {companyId == 1 ? (
            <div className="col-6 col-md-6 mt-3 px-1">
              <div
                className="superadminboxN"
                data-bs-toggle="modal"
                data-bs-target="#superAdminModal"
                onClick={() =>
                  updateModalTitle("Completed In-Clinic Appointments")
                }
              >
                <img
                  src="https://appcdn.goqii.com/storeimg/33669_1684235686.png"
                  alt=""
                  className="imgicon mb-2"
                />
                <h1 className="titlenumbers">
                  {userData.completedInClinicCount}
                </h1>
                <h2 className="subtitle">Completed In-Clinic Appointments</h2>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="col-12 col-sm-6 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Messages from Coach to Patient")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/90527_1731929831.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.coachSentUserReceived ? userData.coachSentUserReceived : 0}</h1>
              <h2 className="subtitle">Messages from Coach to Patient</h2>
            </a>
          </div>

          <div className="col-6 col-md-6 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Messages from Patient to Coach")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/90527_1731929831.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.userSentCoachReceived ? userData.userSentCoachReceived : 0}</h1>
              <h2 className="subtitle">Messages from Patient to Coach</h2>
            </a>
          </div>

          <div className="col-6 col-md-2 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Scheduled Calls")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/26476_1731930269.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.scheduledCalls ? userData.scheduledCalls : 0}</h1>
              <h2 className="subtitle">Total Calls</h2>
            </a>
          </div>

          <div className="col-6 col-md-2 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Completed Calls")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/62955_1731930583.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.completedCalls ? userData.completedCalls : 0}</h1>
              <h2 className="subtitle">Completed Calls</h2>
            </a>
          </div>

          <div className="col-6 col-md-2 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Incomplete Calls")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/20839_1731931059.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.incompleteCalls ? userData.incompleteCalls : 0}</h1>
              <h2 className="subtitle">Incomplete Calls</h2>
            </a>
          </div>

          <div className="col-6 col-md-2 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Missed Calls")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/46802_1731931316.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.missedCalls ? userData.missedCalls : 0}</h1>
              <h2 className="subtitle">Missed Calls</h2>
            </a>
          </div>

          <div className="col-6 col-md-2 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Cancelled Calls")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/65691_1731930796.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.cancelledCalls ? userData.cancelledCalls : 0}</h1>
              <h2 className="subtitle">Cancelled Calls</h2>
            </a>
          </div>

          <div className="col-6 col-md-2 mt-3 px-1">
            <a
              className="superadminboxN"
              data-bs-toggle="modal"
              data-bs-target="#superAdminModal"
              onClick={() => updateModalTitle("Unsuccessful Calls")}
            >
              <img
                src="https://appcdn.goqii.com/storeimg/79726_1731931469.png"
                alt=""
                className="imgicon mb-2"
              />
              <h1 className="titlenumbers">{userData.unsuccessfulCalls ? userData.unsuccessfulCalls : 0}</h1>
              <h2 className="subtitle">Unsuccessful Calls</h2>
            </a>
          </div>

          {/* <div className="col-6 col-md-3 mt-3 px-1">
                        <a className='superadminboxN'>
                            <img src="https://appcdn.goqii.com/storeimg/88760_1681801347.png" alt="" className='imgicon mb-2' />
                            <h1 className='titlenumbers'>{userData.total - userData.loggedIn}</h1>
                            <h2 className='subtitle'>{companyId == 1 ? (<span> Not logged in Patients</span>) : (<span> DNA (Did Not Attend)</span>)}</h2>
                        </a>
                    </div> */}
        </div>

        <div className="row">
          <div className="col-md-6 pe-5 line-r">
            <div className="row">
              <div className="col-8">
                {" "}
                <h1 className="title">Programs</h1>
              </div>
            </div>
            {console.log(
              "program_graph_series",
              seriesGraph.program_graph_series
            )}
            {seriesGraph.loadingStates.program_graph ? (
              <div className="text-center my-5">
                <div style={{color: "#535f7e"}} className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading program data...</p>
              </div>
            ) : (
              seriesGraph.program_graph_series.data && 
              seriesGraph.program_graph_series.data.length > 0 ? (
                <DrawChart1
                  series={seriesGraph.program_graph_series}
                  chartType="pie"
                />
              ) : (
                <NORECORDS />
              )
            )}
          </div>
          <hr className="line d-sm-none" />
          <div className="col-md-6 ps-5" style={{ display: "block" }}>
            <div className="row">
              <div className="col-12">
                <h1 className="title">Coach Rating</h1>
              </div>
            </div>
            {coachRatingData?.length > 0 ? (
              <StarRating
                data={coachRatingData}
                startRange={startRange}
                endRange={endRange}
                divisionClinicFilter={divisionClinicFilter}
                programSelect={programSelect}
              />
            ) : null}
          </div>

          <hr className="line" />
          <div className="col-md-12 ps-5">
            <div style={{ display: "block", padding: "10px" }}>
              <Tabs defaultActiveKey="first">
                <Tab eventKey="first" title="Division">
                  <div className="row">
                    <div className="col-12">
                      <h1 className="title">Division-wise Categorisation</h1>
                    </div>
                  </div>
                  <ChartIncludeColumn
                    series={seriesGraph.divisionSeries}
                    category={seriesGraph.divisionCategory}
                    chartType="column"
                  />
                </Tab>
                <Tab eventKey="second" title="Practice">
                  <div className="row">
                    <div className="col-12">
                      <h1 className="title">Practice-wise Categorisation</h1>
                    </div>
                  </div>

                  {seriesGraph.loadingStates.division_graph ? (
                    <div className="text-center my-5">
                      <div style={{color: "#535f7e"}} className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading division data...</p>
                    </div>
                  ) : (
                    seriesGraph.divisionPracticeSeries && 
                    seriesGraph.divisionPracticeSeries.length > 0 ? (
                      <ChartIncludeColumn
                        series={seriesGraph.divisionPracticeSeries}
                        category={seriesGraph.divisionPracticeCategory}
                        chartType="column"
                      />
                    ) : (
                      <NORECORDS />
                    )
                  )}
                </Tab>
              </Tabs>
            </div>
          </div>

          <hr className="line" />
          <div
            className={
              companyId == 1 ? "col-md-6 pe-5 line-r" : "col-md-12 pe-5"
            }
          >
            <div className="row">
              <div className="col-12">
                <h1 className="title">{graphDuration}Categorisation</h1>
              </div>
            </div>
            {seriesGraph.loadingStates.division_date_graph ? (
              <div className="text-center my-5">
                <div style={{color: "#535f7e"}} className="spinner-border"role="status">
                  <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading division data...</p>
                  </div>
                  ) : (
            seriesGraph.divisionDateSeries &&
            seriesGraph.divisionDateSeries.length > 0 ? (
              <ChartIncludeColumn
                series={seriesGraph.divisionDateSeries}
                category={seriesGraph.divisionDateCategory}
                chartType="column"
              />
            ) : (
              <NORECORDS />
            )
          )}
          </div>

          {companyId == 1 ? (
            <div className="col-md-6 ps-5">
              <hr className="line d-sm-none" />
              <div className="row">
                <div className="col-md-12">
                  <h1 className="title">In-clinic Appointments</h1>
                </div>
              </div>
              {seriesGraph.loadingStates.inclinic_call_graph ? (
                <div className="text-center my-5">
                  <div style={{color: "#535f7e"}} className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading in-clinic call data...</p>
                </div>
              ) : (
              seriesGraph.inclinicCallSeries.data &&
              seriesGraph.inclinicCallSeries.data.length > 0 ? (
                <DrawChart
                  series={seriesGraph.inclinicCallSeries}
                  chartType="pie"
                />
              ) : (
                <NORECORDS />
              )
            )}
            </div>
          ) : (
            ""
          )}
          <hr className="line" />
          <div className="col-md-6 pe-5 line-r">
            <div className="row">
              <div className="col-8">
                <h1 className="title">Gender</h1>
              </div>
            </div>
            <DrawChart
              series={seriesGraph.gender_graph_series}
              chartType="pie"
              color={color}
            />
          </div>
          <hr className="line d-sm-none" />
          <div className="col-md-6 ps-5">
            <div className="row">
              <div className="col-md-12">
                <h1 className="title">Age</h1>
              </div>
            </div>
            <DrawChart series={seriesGraph.age_graph_series} chartType="pie" />
          </div>

          <hr className="line" />
          <div className="col-md-6 pe-5 line-r">
            <div className="row">
              <div className="col-8">
                <h1 className="title">Call Details</h1>
              </div>
            </div>
            {seriesGraph.loadingStates.call_detail_graph ? (

              <div className="text-center my-5" style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "400px" // Adjust this value to match your graph height
              }}>
                <div style={{color: "#535f7e"}} className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading call data...</p>
              </div>
            ) : (
            seriesGraph.callDetailSeries &&
            seriesGraph.callDetailSeries.length > 0 ? (
              <ChartIncludeColumn
                series={seriesGraph.callDetailSeries}
                category={seriesGraph.callDetailCategory}
                chartType="column"
              />
            ) : (
              <NORECORDS />
            )
          )}
          </div>
          <hr className="line d-sm-none" />
          <div className="col-md-6 ps-5">
            <div className="row">
              <div className="col-md-12">
                <h1 className="title">Message Details</h1>
              </div>
            </div>
            {seriesGraph.loadingStates.message_graph ? (

              <div className="text-center my-5"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "400px" // Adjust this value to match your graph height
              }}>
                <div style={{color: "#535f7e"}} className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading message data...</p>
              </div>
            ) : (
            seriesGraph.mesageGraphSeries &&
            seriesGraph.mesageGraphSeries.length > 0 ? (
              <ChartIncludeColumn
                series={seriesGraph.mesageGraphSeries}
                category={seriesGraph.mesageGraphCategory}
                chartType="column"
              />
            ) : (
              <NORECORDS />
            )
          )}
          </div>
        </div>
        {loading ? <CustomLoader /> : ""}
      </section>

      {/* Modal */}
      <div
        className="modal fade"
        id="superAdminModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl" style={{ maxWidth: "96%" }}>
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ paddingBottom: "0px", border: "none" }}
            >
              <h1 className="modal-title fs-5" id="modalTitle">
                {modalTitle || "Modal title"}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            {modalTitle && modalTitle === "Active Patients" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Program Name</th>
                                <th scope="col">SMS Sent Date</th>
                                <th scope="col">SMS Delivered Date</th>
                              </>
                            ) : modalTitle === "Fully Onboarded Patients" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Program Name</th>
                                <th scope="col">SMS Sent Date</th>
                                <th scope="col">SMS Delivered Date</th>
                                <th scope="col">Logged In Date</th>
                                <th scope="col">Onboarding Date</th>
                              </>
                            ) : modalTitle ===
                              "Partially Registered Patients" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Program Name</th>
                                <th scope="col">SMS Sent Date</th>
                                <th scope="col">SMS Delivered Date</th>
                                <th scope="col">Logged In Date</th>
                              </>
                            ) : modalTitle ===
                              "Scheduled In-Clinic Appointments" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                {/* <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th> */}
                                <th scope="col">Date Appointment Booked on</th>
                                <th scope="col">Appointment Date</th>
                                <th scope="col">Appointment Status</th>
                              </>
                            ) : modalTitle ===
                              "Completed In-Clinic Appointments" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                {/* <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th> */}
                                <th scope="col">Date Appointment Booked on</th>
                                <th scope="col">Appointment Date</th>
                                <th scope="col">Appointment Status</th>
                                <th scope="col">Date of Completion</th>
                              </>
                            ) : modalTitle === "Accounts Created" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Program Name</th>
                                <th scope="col">SMS Sent Date</th>
                                <th scope="col">SMS Delivered Date</th>
                              </>
                            ) : modalTitle === "In-Active Patients" ? (
                              <>
                                <th scope="col" className="text-start">
                                  Patient Name
                                </th>
                                <th scope="col">NHS ID</th>
                                <th scope="col">Mobile Number</th>
                                <th scope="col">Program Name</th>
                                <th scope="col">SMS Sent Date</th>
                                <th scope="col">SMS Delivered Date</th>
                                <th scope="col">Onboarding Date</th>
                              </>
                            ) : (
                              <>
                                <th scope="col" className="text-start">
                                  Year
                                </th>
                                <th scope="col">Month/Week/Date</th>
                                <th scope="col">Conversation Count</th>
                              </>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedContent && paginatedContent.length > 0 ? (
                            paginatedContent.map((item, index) => {
                              const formattedSentDate =
                                item.smssentdate &&
                                item.smssentdate !== "0000-00-00 00:00:00"
                                  ? new Date(
                                      item.smssentdate
                                    ).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })
                                  : "-";
                              const formattedDeliveredDate =
                                item.smsdeliverdate &&
                                item.smsdeliverdate !== "0000-00-00 00:00:00"
                                  ? new Date(
                                      item.smsdeliverdate
                                    ).toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })
                                  : "-";
                              const formattedOnboardingDate = new Date(
                                item.onboarding_date
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              });
                              const formattedLoginDate = new Date(
                                item.loginDate
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              });
                              const formattedScheduledDate = new Date(
                                item.appointment_scheduled_on
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              });
                              const formattedCompletedDate = new Date(
                                item.appointment_completed_on
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              });

                              return (
                                <>
                                  {modalTitle &&
                                  modalTitle == "Active Patients" ? (
                                    <tr key={index}>
                                      <th
                                        scope="row"
                                        className="text-start ps-2"
                                      >
                                        {item.patient_name}
                                      </th>
                                      <td>{item.NHS_Id}</td>
                                      <td>{item.mobile}</td>
                                      <td>{item.program_names}</td>
                                      <td>{formattedSentDate}</td>
                                      <td>{formattedDeliveredDate}</td>
                                    </tr>
                                  ) : (
                                    <>
                                      {" "}
                                      {modalTitle &&
                                      modalTitle ==
                                        "Fully Onboarded Patients" ? (
                                        <tr key={index}>
                                          <th
                                            scope="row"
                                            className="text-start ps-2"
                                          >
                                            {item.patient_name}
                                          </th>
                                          <td>{item.nhsNumber}</td>
                                          <td>{item.mobile}</td>
                                          <td>{item.program_names}</td>
                                          <td>{formattedSentDate}</td>
                                          <td>{formattedDeliveredDate}</td>
                                          <td>{formattedLoginDate}</td>
                                          <td>{formattedOnboardingDate}</td>
                                        </tr>
                                      ) : (
                                        <>
                                          {" "}
                                          {modalTitle &&
                                          modalTitle == "Accounts Created" ? (
                                            <tr key={index}>
                                              <th
                                                scope="row"
                                                className="text-start ps-2"
                                              >
                                                {item.patient_name}
                                              </th>
                                              <td>{item.nhsNumber}</td>
                                              <td>{item.mobile}</td>
                                              <td>{item.program_names}</td>
                                              <td>{formattedSentDate}</td>
                                              <td>{formattedDeliveredDate}</td>
                                            </tr>
                                          ) : (
                                            <>
                                              {" "}
                                              {modalTitle &&
                                              modalTitle ==
                                                "In-Active Patients" ? (
                                                <tr key={index}>
                                                  <th
                                                    scope="row"
                                                    className="text-start ps-2"
                                                  >
                                                    {item.patient_name}
                                                  </th>
                                                  <td>{item.nhsNumber}</td>
                                                  <td>{item.mobile}</td>
                                                  <td>{item.program_names}</td>
                                                  <td>{formattedSentDate}</td>
                                                  <td>
                                                    {formattedDeliveredDate}
                                                  </td>
                                                  <td>
                                                    {formattedOnboardingDate}
                                                  </td>
                                                </tr>
                                              ) : (
                                                <>
                                                  {modalTitle &&
                                                  modalTitle ==
                                                    "Partially Registered Patients" ? (
                                                    <tr key={index}>
                                                      <th
                                                        scope="row"
                                                        className="text-start ps-2"
                                                      >
                                                        {item.patient_name}
                                                      </th>
                                                      <td>{item.nhsNumber}</td>
                                                      <td>{item.mobile}</td>
                                                      <td>
                                                        {item.program_names}
                                                      </td>
                                                      <td>
                                                        {formattedSentDate}
                                                      </td>
                                                      <td>
                                                        {formattedDeliveredDate}
                                                      </td>
                                                      <td>
                                                        {formattedLoginDate}
                                                      </td>
                                                    </tr>
                                                  ) : (
                                                    <>
                                                      {modalTitle &&
                                                      modalTitle ==
                                                        "Scheduled In-Clinic Appointments" ? (
                                                        <tr key={index}>
                                                          <th
                                                            scope="row"
                                                            className="text-start ps-2"
                                                          >
                                                            {item.patient_name}
                                                          </th>
                                                          {/* <td>
                                                            {item.nhsNumber}
                                                          </td>
                                                          <td>{item.mobile}</td> */}
                                                          <td>
                                                            {
                                                              formattedScheduledDate
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              formattedScheduledDate
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              item.appointment_status
                                                            }
                                                          </td>
                                                        </tr>
                                                      ) : (
                                                        <>
                                                          {modalTitle &&
                                                          modalTitle ==
                                                            "Completed In-Clinic Appointments" ? (
                                                            <tr key={index}>
                                                              <th
                                                                scope="row"
                                                                className="text-start ps-2"
                                                              >
                                                                {
                                                                  item.patient_name
                                                                }
                                                              </th>
                                                              {/* <td>
                                                                {item.nhsNumber}
                                                              </td>
                                                              <td>
                                                                {item.mobile}
                                                              </td> */}
                                                              <td>
                                                                {
                                                                  formattedScheduledDate
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  formattedScheduledDate
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  item.appointment_status
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  formattedCompletedDate
                                                                }
                                                              </td>
                                                            </tr>
                                                          ) : (
                                                            <tr key={index}>
                                                              <th
                                                                scope="row"
                                                                className="text-start ps-2"
                                                              >
                                                                {item.yearCount}
                                                              </th>
                                                              <td>
                                                                {item.monthCount ||
                                                                  item.weekCount ||
                                                                  item.Date}
                                                              </td>
                                                              <td>
                                                                {
                                                                  item.total_conversations
                                                                }
                                                              </td>
                                                            </tr>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination Controls */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <button
                        className="btn btn-primary"
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <span>
                        Page{" "}
                        {modalContent && modalContent.length > 5
                          ? currentPage
                          : 0}{" "}
                        of {totalPages ? totalPages : 0}
                      </span>
                      <button
                        className="btn btn-primary"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                    <div className="mt-3 text-end">
                      {showExportButton && (
                        <button
                          className="btn btn-success me-2"
                          onClick={fetchExportData}
                          disabled={loadingExport}
                        >
                          {loadingExport
                            ? "Exporting..."
                            : "Prepare Data to Download"}
                        </button>
                      )}
                      {csvData.length > 0 && (
                        <CSVLink
                          headers={headers}
                          data={csvData}
                          filename={`${modalTitle
                            .replace(/\s+/g, "_")
                            .toLowerCase()}.csv`}
                          className="btn btn-success"
                          disabled={loadingExport}
                        >
                          Export to CSV
                        </CSVLink>
                      )}
                    </div>
                    {/* <div className="mt-3 text-end">
                      <button
                        className="btn btn-success"
                        onClick={fetchExportData}
                        disabled={loadingExport}
                      >
                        {loadingExport ? "Exporting..." : "Fetch and Export Data"}
                      </button>

                      <CSVLink
                        headers={headers}
                        data={csvData}
                        filename={`${modalTitle.replace(/\s+/g, "_").toLowerCase()}.csv`}
                        className="d-none"
                        id="csv-link"
                      /> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default HomeSuperAdmin;
